var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserListView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.5H5C4.44772 2.5 4 2.94772 4 3.5V21.5C4 22.0523 4.44772 22.5 5 22.5H19C19.5523 22.5 20 22.0523 20 21.5V3.5C20 2.94772 19.5523 2.5 19 2.5Z",
    stroke: "#E2E3E3",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5H16.5",
    stroke: "#E2E3E3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5H16.5",
    stroke: "#E2E3E3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 17.5H16.5",
    stroke: "#E2E3E3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.5C8.0523 8.5 8.5 8.0523 8.5 7.5C8.5 6.9477 8.0523 6.5 7.5 6.5C6.9477 6.5 6.5 6.9477 6.5 7.5C6.5 8.0523 6.9477 8.5 7.5 8.5Z",
    fill: "#E2E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.5C8.0523 13.5 8.5 13.0523 8.5 12.5C8.5 11.9477 8.0523 11.5 7.5 11.5C6.9477 11.5 6.5 11.9477 6.5 12.5C6.5 13.0523 6.9477 13.5 7.5 13.5Z",
    fill: "#E2E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 18.5C8.0523 18.5 8.5 18.0523 8.5 17.5C8.5 16.9477 8.0523 16.5 7.5 16.5C6.9477 16.5 6.5 16.9477 6.5 17.5C6.5 18.0523 6.9477 18.5 7.5 18.5Z",
    fill: "#E2E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserListView);
export default __webpack_public_path__ + "static/media/userList-view.0d1bfdb2dfad8739f54400a76508097b.svg";
export { ForwardRef as ReactComponent };